import axios, { CancelToken } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import { IGetActiveMemberRequest } from '@ace-clublabs/common-membership-api-types';
import { GetActiveMember } from '../contracts/GetActiveMember';
import StatusCode from 'status-code-enum';

export const GetActiveMemberApi =
  (endpoint: string): GetActiveMember =>
  async (request: IGetActiveMemberRequest, cancelToken?: CancelToken) => {
    try {
      const config = { ...createAxiosConfig(endpoint), cancelToken };
      const response = await axios.post(endpoint, request, config);
      LogCannon.blast('GetActiveMemberApi success');
      return Promise.resolve(response.data);
    } catch (e: any) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('GetActiveMemberApi error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Get active member failed',
          ...errorResponse,
        },
      });
    }
  };
